import { render, staticRenderFns } from "./NoticeManagementEnrollment.vue?vue&type=template&id=ffab034c&"
import script from "./NoticeManagementEnrollment.vue?vue&type=script&lang=js&"
export * from "./NoticeManagementEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports